import { graphql } from "@opensea/graphql"

export const AcceptOfferStatus_itemFragment = graphql(`
  fragment AcceptOfferStatus_item on Item {
    imageUrl
  }
`)
